/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Print_AdminInputs */

const vi_nav_print_admin = /** @type {(inputs: Nav_Print_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hệ thống in`)
};

/**

* @param {Nav_Print_AdminInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_print_admin = /** @type {((inputs?: Nav_Print_AdminInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Print_AdminInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_print_admin(inputs)
});